import * as types from '../constants/ActionTypes';
import { contactPage } from '../constants/UtilVariables';

const initialState = {
  isLoading: false,
  error: false,
  display: true,
  topicTreeSelection: undefined,
  topicTreeSelectionL1: undefined,
  topicTreeSelectionL2: undefined,
  topicTreeSelectionL3: undefined,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_TOPIC_TREE:
      return { ...state, isLoading: true };
    case types.RECEIVE_TOPIC_TREE_ERROR:
      return { ...state, isLoading: false, error: true };
    case types.RECEIVE_TOPIC_TREE_RESPONSE:
      return {
        ...state,
        isLoading: false,
        error: false,
        topicTreeSelection: action.payload,
      };
    case types.SELECT_TOPIC_L1:
      return {
        ...state,
        isLoading: false,
        error: false,
        topicTreeSelectionL1: action.payload,
      };
    case types.SELECT_TOPIC_L2:
      return {
        ...state,
        isLoading: false,
        error: false,
        topicTreeSelectionL2: action.payload,
      };
    case types.SELECT_TOPIC_L3:
      return {
        ...state,
        isLoading: false,
        error: false,
        topicTreeSelectionL3: action.payload,
      };
    case types.REQUEST_BY_EMAIL:
    case types.RECEIVE_EMPTY_FIELDS:
      return { ...state, display: false };
    case types.CHANGE_TOPIC:
    case types.CANCEL_EMAIL_FORM:
    case types.CANCEL_EMAIL_FORM_NO_INTENT:
      return { ...state, display: true };
    case types.CONTACT_LOCATION_CHANGE: {
      if (action.payload && action.payload.pageName === contactPage.email) {
        return { ...state, display: true };
      }
      return state;
    }
    default:
      return state;
  }
}
